(() => {
  const root = document.documentElement;
  const mobile = window.matchMedia('(max-width: 767.98px)');
  let bars = [];
  let frame;

  const update = () => {
    let clearance = 0;
    if (mobile.matches) {
      bars.forEach((bar) => {
        if (!bar.classList.contains('sticky-atc-bar--show') || !bar.getClientRects().length) return;
        const bottom = parseFloat(getComputedStyle(bar).bottom) || 0;
        clearance = Math.max(clearance, bar.offsetHeight + Math.max(0, bottom));
      });
    }
    root.toggleAttribute('data-niccos-chat-clearance', clearance > 0);
    if (clearance > 0) root.style.setProperty('--niccos-chat-clearance', `${Math.ceil(clearance)}px`);
    else root.style.removeProperty('--niccos-chat-clearance');
  };

  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(update);
  };
  const resize = new ResizeObserver(schedule);
  const changes = new MutationObserver(schedule);
  const bind = () => {
    resize.disconnect();
    changes.disconnect();
    bars = [...document.querySelectorAll('.sticky-atc-bar')];
    bars.forEach((bar) => {
      resize.observe(bar);
      changes.observe(bar, { attributes: true, attributeFilter: ['class', 'style'] });
    });
    changes.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    schedule();
  };

  mobile.addEventListener('change', schedule);
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:section:unload', bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
})();
